import Environment from '../environment/Environment';
import { postRequest, HandlerResponse } from './api';

/**
*  Below function will create a new access token from refresh token.
* This Api call is mandatory to call before any application Api call.
* It will set the session storage with new access token to keep the session alive while
* using the application.
* 
*/
export const genearteNewToken = () =>{
  let refreshToken = sessionStorage.getItem(`refreshToken`);
  //console.log(refreshToken);
    const URL = `${Environment.API}/keycloak/getToken/newtknrequest`;
    const payload={
      refreshToken,
    }
    let newToken='';
    postRequest(URL, payload).then((resp: any) => HandlerResponse(resp)).then((response)=>{
      if(response){
        newToken = response.tkn;
        sessionStorage.removeItem(`token`);
        sessionStorage.setItem(`token`, newToken);
      }
    });
        
  }